// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"DY-z","subtitle":"EY-z","wrapper":"FY-z","leftArrow":"GY-z","rightArrow":"HY-z"};